<template>
    <div>
        <div class="step-box">
            <div class="step_left">
                <div class="step_left_img">
                    <img :src=stepLeftImg>
                </div>
                <div class="step_left_title">
                    <p>{{ stepLeftTitle }}</p>
                </div>
            </div>
            <div class="step_right">
                <div class="step_right_top">
                    <div class="step_right_top_img">
                        <img src="../../assets/images/ellipse.png" alt="">
                    </div>
                    <div class="step_right_top_text">
                        {{ stepRightTopText }}
                    </div>
                </div>
                <div class="step_right_bottom" ref="step_right_bottom" v-html="stepRightBottom">
                </div>
            </div>

        </div>
        <process 
            :type="type"
            v-if="!end"
            :processConfig="processConfig"
            ref="process"
        >

        </process>
    </div>

</template>

<script>
import process from './process.vue'
export default {
    name: "step",
    data() {
        return {

        }
    },

    props: [
        'stepLeftTitle', 
        'stepRightTopText', 
        'stepRightBottom', 
        'stepLeftImg', 
        'type',
        'end',
        'processConfig'
    ],

    watch: {},

    components: {
        process
    },

    computed: {},

    created() {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.step-box {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;

    .step_left {
        width: 105px;
        margin-right: 90px;

        .step_left_img {
            width: 80px;
            height: 80px;
            margin: auto;
            margin-bottom: 10px;

            >img {
                height: 100%;
                width: 100%;
            }
        }

        .step_left_title {
            font-size: 20px;
            font-weight: bold;
            color: #05A2E1;
            line-height: 26px;
        }
    }

    .step_right {
        width: 85%;

        .step_right_top {
            background-color: rgba(5,162,225,0.04);
            height: 60px;
            width: 100%;
            padding-left: 20px;
            margin-bottom: 16px;
            box-sizing: border-box;
            text-align: left;
            display: flex;
            align-items: center;

            .step_right_top_img {
                height: 20px;
                width: 20px;
                margin-right: 10px;
                >img {
                    height: 100%;
                    width: 100%;
                }
            }

            .step_right_top_text {
                font-size: 20px;
                font-weight: bold;
                color: #222222;
                line-height: 26px;
            }
        }

        .step_right_bottom {
            font-size: 16px;
            color: #666666;
            line-height: 31px;
            text-align: left;
            text-indent: 2em;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/step/step.vue